import { render, staticRenderFns } from "./RegisterStep5.vue?vue&type=template&id=67722122&scoped=true"
import script from "./RegisterStep5.vue?vue&type=script&lang=js"
export * from "./RegisterStep5.vue?vue&type=script&lang=js"
import style0 from "./RegisterStep5.vue?vue&type=style&index=0&id=67722122&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67722122",
  null
  
)

export default component.exports